// Checks if item is present in array, if it is, removes it, otherwise, adds it.
// Useful for checkboxes.
export const toggleItem = (array, item) => {
  if (array.find(i => i.id === item.id)) {
    return array.filter(i => i.id !== item.id)
  } else {
    return [...array, item]
  }
}